module.exports = __webpack_public_path__ + "static/media/siel-bleu-ireland.07ed0f84.svg";